<div id="form-container" class="col-12">
  <form id="payment-form">
    <div
      class="form-group m-form__group row stripepayment stripe-payment-element-new material-form-field-label"
    >
      <div id="payment-element"></div>
    </div>
  </form>
</div>
